import { AllTransferActionResponseModel, TransferActionResponseModel } from '@gtpl/shared-models/hrms';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { Controller, Post, Body, Req, All } from '@nestjs/common';
import { ApiTags } from '@nestjs/swagger';
import { TransferActionDTO } from './dto/transfer-action.dto';
import { TransferActionRequest } from './dto/transfer-action-request';
import { TransferActionService } from './transfer-action.service';

@ApiTags('transfer-action')
@Controller('transfer-action')
export class TransferActionController {

    constructor(
        private service: TransferActionService,
        private readonly applicationExceptionHandler: ApplicationExceptionHandler
    ){}

    @Post('/createTransferAction')
    async createTransferAction(@Body() DTO: TransferActionDTO, isUpdate: boolean = false): Promise<TransferActionResponseModel>{
        try{
            return await this.service.createTransferAction(DTO, false);
        }catch(error){
            return this.applicationExceptionHandler.returnException(TransferActionResponseModel, error);
        }
    }

    @Post('/updateTransferAction')
    async updateTransferAction(@Body() DTO: TransferActionDTO, isUpdate: boolean = false): Promise<TransferActionResponseModel>{
        try{
            return await this.service.createTransferAction(DTO, true);
        }catch(error){
            return this.applicationExceptionHandler.returnException(TransferActionResponseModel, error);
        }
    }

    @Post('/getAllTransferActions')
    async getAllTransferActions(): Promise<AllTransferActionResponseModel>{
        try{
            return await this.service.getAllTransferActions();
        }catch(error){
            return this.applicationExceptionHandler.returnException(AllTransferActionResponseModel, error);
        }
    }

    @Post('/getAllActiveTransferActions')
    async getAllActiveTransferActions(): Promise<AllTransferActionResponseModel>{
        try{
            return await this.service.getAllActiveTransferActions();
        }catch(error){
            return this.applicationExceptionHandler.returnException(AllTransferActionResponseModel, error);
        }
    }

    @Post('/activateOrDeactivateTransferAction')
    async activateOrDeactivateTransferAction(@Body() Req: TransferActionRequest): Promise<TransferActionResponseModel>{
        try{
            return await this.service.activateOrDeactivateTransferAction(Req);
        }catch(error){
            return this.applicationExceptionHandler.returnException(TransferActionResponseModel, error);
        }
    }
}
